module.exports = __webpack_public_path__ + "static/img/activity_entry_returnscore.44ad205f.png";